import loadable from '@loadable/component';

export const OrgDashboardViewInternshipPageContainerLoadable = loadable(
  () => import('./OrgDashboardViewInternshipPageContainer'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardViewInternshipPageContainer,
  },
);
